const SectionPage = ({ children }) => (
  <div className="section-page">
    {children}
  </div>
);

export default SectionPage;
